import {Button, ButtonProps} from "flowbite-react";

export function ActionButton(props: ButtonProps) {
    return (
        <Button
            {...props}
            className={`${props.className ?? ""} hover:bg-gray-600 dark:enabled:hover:bg-gray-600 w-full disabled:bg-gray-800 focus:ring-1 focus:ring-gray-really dark:focus:ring-gray-really p-2 text-base`}
        >
        </Button>
    )
}
